"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const THUMBNAIL_SIZES = ['high', 'medium', 'standard', 'default'];
function getThumbnail(thumbnails) {
    if (!thumbnails) {
        return undefined;
    }
    const biggestThumbByWidth = _(thumbnails).values().maxBy('width');
    const biggestAvailableSize = _(THUMBNAIL_SIZES)
        .takeWhile((size) => _.has(thumbnails, size))
        .head();
    const biggestThumbnail = biggestThumbByWidth || thumbnails[biggestAvailableSize];
    return biggestThumbnail && biggestThumbnail.url.replace(/^https?:/, '');
}
exports.default = getThumbnail;
//# sourceMappingURL=get-thumbnail.js.map